import React, { useState, useEffect } from "react";
import { Container } from "components";
import Footer from "components/footer";
import api from "services/api";
import { useParams, Link } from "react-router-dom";
import QRCode from "qrcode.react";
import moment from "moment";

const MemebershipsDetails = () => {
  const [memberships, setMemberships] = useState([]);
  const params = useParams();


  const fetchMembershipData = React.useCallback(async () => {
    try {
      const response = await api.get(
        `/membership-application?applicationNo=${params.id}`
      );
      const memberAppNo = response?.data?.data?.memberApplication;
      setMemberships(memberAppNo);
      console.log("membershipPersonDetails:", memberAppNo);
    } catch (error) {
      console.log("membershipPersonDetails error:", error);
    }
  }, [params.id]);

  useEffect(() => {
    fetchMembershipData();
  }, [fetchMembershipData]);

  return (
    <Container>
      <div class="content-wrapper">
        <div
          class="container-xxl flex-grow-1 container-p-y"
          style={{ height: "43px" }}
        >
          {/* <ul className="nav nav-pills flex-column flex-md-row mb-4">
            <li className="nav-item">
              <h4 className={` py-2 mb-2`}>
                <span className="text-muted">
                <Link to="/enrolledPlans" className="text-muted"> Plans /</Link>
                </span>Memberships Details</h4>
            </li>
          </ul> */}
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <Link to="/enrolledPlans">Plans</Link>
              </li>
              <li class="breadcrumb-item active">Memberships details</li>
            </ol>
          </nav>
          <div class="card mb-4">
            {memberships.map((membershipPersonData, index) => {
              return (
                <div class="card-body" key={index}>
                  <div class="row">
                    <div className="col-md-2 col-0"></div>
                    <div class="col-md-4 col-12 mb-1 ">
                      <div class="customer-avatar-section">
                        <img
                          class="img-fluid rounded my-3"
                          src={
                            membershipPersonData?.kyc_details?.status ===
                              "Not-submitted"
                              ? membershipPersonData?.kyc_details?.userImage
                              : membershipPersonData?.kyc_details?.user_image
                          }
                          style={{ width: "120px", height: "120px" }}
                          alt="User avatar"
                        />
                        <div class="customer-info ">
                          <h4 class="mb-1">
                            {membershipPersonData.first_name}{" "}
                            {membershipPersonData.middle_name}{" "}
                            {membershipPersonData.last_name}
                          </h4>
                        </div>
                      </div>
                      <div class="info-container">
                        <ul class="list-unstyled mt-3">
                          <li class="mb-2">
                            <span class="fw-medium me-2">Email :</span>
                            <span>{membershipPersonData?.email}</span>
                          </li>
                          <li class="mb-2">
                            <span class="fw-medium me-2">DOB :</span>
                            <span>
                              {moment(membershipPersonData.dob).format(
                                "DD-MM-YYYY"
                              )}
                            </span>
                          </li>
                          <li class="mb-2">
                            <span class="fw-medium me-2">Status :</span>
                            <span
                              className={`badge ${membershipPersonData.status === "Pending"
                                  ? "bg-warning"
                                  : membershipPersonData.status === "Approved"
                                    ? "bg-success"
                                    : "bg-danger"
                                }`}
                            >
                              {membershipPersonData.status}
                            </span>
                          </li>
                          <li class="mb-2">
                            <span class="fw-medium me-2">Contact :</span>
                            <span> {membershipPersonData.phone_no}</span>
                          </li>
                          <li class="mb-2">
                            <span class="fw-medium me-2">KYC Status :</span>
                            <span
                              className={`badge ${membershipPersonData.kyc_details.status ===
                                  "Pending"
                                  ? "bg-warning"
                                  : membershipPersonData.kyc_details.status ===
                                    "Approved"
                                    ? "bg-success"
                                    : "bg-danger"
                                }`}
                            >
                              {membershipPersonData.kyc_details.status}
                            </span>
                          </li>

                          <li class="mb-2">
                            <span class="fw-medium me-2">Country :</span>
                            <span>{membershipPersonData.country}</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-md-4 col-12 mb-1 ">
                      <div className="d-flex align-items-end">
                        <div
                          className="col-md-9"
                          style={{ paddingTop: "13px" }}
                        >
                          <QRCode
                            value={`https://zenosure.com/checkMembership?membershipid=${membershipPersonData.application_no}`}
                            size={150}
                          />
                          <div className="text-left">
                            <div class="mb-3">
                              <h6 class="mb-1">Your Current Plan is Basic </h6>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html:
                                    membershipPersonData.membership_plan.title,
                                }}
                              />
                            </div>
                            <div class="mb-3">
                              <h6 class="mb-1">
                                Active until{" "}
                                {membershipPersonData.end_date
                                  ? moment(
                                    membershipPersonData.end_date
                                  ).format("DD-MM-YYYY")
                                  : "N/A"}
                              </h6>
                              <p>
                                We will send you a notification upon
                                Subscription expiration
                              </p>
                            </div>
                            <div class="mb-3">
                              <h6 class="mb-1">APPLICATION NUMBER </h6>
                              <p>{membershipPersonData?.application_no}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <Footer />
        <div class="content-backdrop fade"></div>
      </div>
    </Container>
  );
};

export default MemebershipsDetails;
